export default __webpack_public_path__ + "static/media/eh.799b45ba.svg";